<template>
  <!-- 问卷列表 -->
  <div class="bigcontent columnFlx">
    <div class="top columnFlx" style="margin-top: 2px">
      <div class="topfirst betweenFlx" style="margin-bottom: 0">
        <div class="topfirst">
          <!-- <div class="inpstyle">
            <span>问卷ID:</span>
            <el-input type="text" v-model="queryParams.id" placeholder="单行输入"></el-input>
          </div> -->
          <div class="inpstyle">
            <p>问卷名称:</p>
            <el-input
              type="text"
              v-model="queryParams.questionnaireName"
              placeholder="单行输入"
              style="width: 185px"
            ></el-input>
          </div>
          <!-- <div class="inpstyle">
            <span>用户ID:</span>
            <el-input type="text" v-model="queryParams.userKey" placeholder="单行输入"></el-input>
          </div> -->
          <div class="inpstyle">
            <p>发布状态:</p>
            <el-select
              v-model="queryParams.releaseStatus"
              placeholder="请选择"
              clearable
              ref="loanStatusSelect1"
              style="width: 185px"
            >
              <el-option
                v-for="item in stateDic"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <el-button @click="getListReset">重置</el-button>
          <el-button type="primary" @click="getDataOne">查询</el-button>
          <!-- <el-button type="success" @click="handleExport">导出</el-button> -->
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#F6F7FA' }"
        :cell-style="{ background: '#ffffff' }"
		:empty-text="loading ? '加载中' : '暂无数据'"
      >
        <el-table-column
          prop="questionnaireName"
          label="问卷名称"
          align="left"
          width="400px"
          class-name="custom-questionnaire-column"
        >
          <template slot-scope="scope">
            <span
              style="cursor: pointer; color: #1877ff"
              :class="
                scope.row.ifTop == 1 || scope.row.ifTop === '1' ? 'text' : ''
              "
              @click="handleShareClick(scope.row)"
              >{{ scope.row.questionnaireName }}
            </span>
            <span
              class="ifTop"
              v-if="scope.row.ifTop == 1 || scope.row.ifTop === '1'"
              >置顶</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="dataNum" label="参与人数" align="center">
        </el-table-column>
        <el-table-column prop="questionNum" label="题目数量" align="center">
        </el-table-column>
        <el-table-column prop="browseNum" label="浏览数量" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="问卷创建时间" align="center">
        </el-table-column>
        <!-- <el-table-column label="状态" width="auto" align="center">
          <template slot-scope="scope">
            {{ scope.row.status == 0 ? '正常' : '停用' }}
          </template>
</el-table-column> -->
        <!-- <el-table-column prop="releaseStatus" label="发布状态" align="center">
          <template slot-scope="scope">
            <span :class="{
              'isReleaseTrue': scope.row.releaseStatus == 1,
              'isReleaseFalse': scope.row.releaseStatus == 2,
              'isRelease': scope.row.releaseStatus == 0
            }">
              {{ scope.row.releaseStatus == 0 ? '草稿' : scope.row.releaseStatus == 1 ? '已发布' : '未发布' }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column prop="releaseStatus" label="发布状态" align="center">
          <template slot-scope="scope">
            <span
              :class="[
                scope.row.releaseStatus === 1
                  ? 'isReleaseTrue'
                  : 'isReleaseFalse',
              ]"
            >
              {{ scope.row.releaseStatus == 1 ? "已发布" : "未发布" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <!-- .releaseStatus == 1 已发布、、未发布 -->
            <el-button
              @click.native.prevent="editClick(tableData[scope.$index])"
              type="text"
              size="small"
            >
              重新编辑
            </el-button>
            <el-button
              v-if="scope.row.releaseStatus == 1"
              @click.native.prevent="handleShareClick(tableData[scope.$index])"
              type="text"
              size="small"
            >
              分享转发
            </el-button>
            <el-button
              v-else
              @click.native.prevent="fbClick(tableData[scope.$index])"
              type="text"
              size="small"
            >
              发布问卷
            </el-button>
            <el-dropdown
              v-if="scope.row.releaseStatus == 1"
              @command="handleCommand"
            >
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(
                      scope.$index,
                      scope.row,
                      scope.row.ifTop == 1 || scope.row.ifTop === '1'
                        ? '取消置顶'
                        : '置顶'
                    )
                  "
                >
                  {{
                    scope.row.ifTop == 1 || scope.row.ifTop === "1"
                      ? "取消置顶"
                      : "置顶"
                  }}
                </el-dropdown-item>
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(scope.$index, scope.row, '数据统计')
                  "
                  >数据统计</el-dropdown-item
                >
                <!-- <el-dropdown-item
                  :command="beforeHandleCommand(scope.$index, scope.row, '重新编辑')">重新编辑</el-dropdown-item> -->
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(scope.$index, scope.row, '创建副本')
                  "
                  >创建副本</el-dropdown-item
                >
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(scope.$index, scope.row, '结束问卷')
                  "
                  >结束问卷</el-dropdown-item
                >
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(scope.$index, scope.row, '删除问卷')
                  "
                  >删除问卷</el-dropdown-item
                >
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(scope.$index, scope.row, '管理员设置')
                  "
                  >管理员设置</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown v-else @command="handleCommand">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(
                      scope.$index,
                      scope.row,
                      scope.row.ifTop == 1 || scope.row.ifTop === '1'
                        ? '取消置顶'
                        : '置顶'
                    )
                  "
                >
                  {{
                    scope.row.ifTop == 1 || scope.row.ifTop === "1"
                      ? "取消置顶"
                      : "置顶"
                  }}
                </el-dropdown-item>
                <!-- <el-dropdown-item
                  :command="beforeHandleCommand(scope.$index, scope.row, '重新编辑')">重新编辑</el-dropdown-item> -->
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(scope.$index, scope.row, '数据统计')
                  "
                  >数据统计</el-dropdown-item
                >
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(scope.$index, scope.row, '创建副本')
                  "
                  >创建副本</el-dropdown-item
                >
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(scope.$index, scope.row, '删除问卷')
                  "
                  >删除问卷</el-dropdown-item
                >
                <el-dropdown-item
                  :command="
                    beforeHandleCommand(scope.$index, scope.row, '管理员设置')
                  "
                  >管理员设置</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <!--  -->
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="queryParams.pageSize"
          :current-page="currentPage"
          :total="total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="分享" :visible.sync="dialogVisible" width="800px">
      <div style="display: flex; padding: 40px; background: #fff">
        <div
          class="left-panel"
          style="
            background-image: url('https://ai-public.mastergo.com/ai/img_res/c85e4dd3c85760773fb9d40f30d1914a.jpg');
            background-size: 100% 100%;
          "
        >
          <div class="card">
            <h2 class="card-title">{{ this.clickItem.questionnaireName }}</h2>
            <img :src="clickItem.qrCode" class="qr-code" />
          </div>
        </div>
        <!-- 右侧信息区 -->
        <div class="right-panel">
          <div class="info-box">
            <h2 class="info-title">问卷信息</h2>
            <p class="info-item">问卷名称: {{ clickItem.questionnaireName }}</p>
            <p class="info-item">
              问卷备注: {{ clickItem.questionnaireDescribe }}
            </p>
          </div>

          <div class="link-box">
            <h2 class="link-title">问卷链接</h2>
            <div
              style="
                width: 100%;
                border: solid 1px #efefef;
                padding: 4px;
                height: 40px;
              "
            >
              <input
                type="text"
                style="width: 100%; height: 40px"
                readonly
                :value="clickItem.qrCode"
              />
            </div>

            <div class="btn-group">
              <button class="btn" @click="copyClick">复制链接</button>
              <button class="btn" @click="downs">下载图片</button>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <questionTemplate
      :showDialog="showDialog"
      @close-dialog="showDialog = false"
      :params="{ id: lookId, type: 2 }"
      @update="getData"
    ></questionTemplate>
    <div>
      <div class="coverShow" v-show="showCollaborator">
        <div class="container-gj" @click="showAnalysis = false">
          <div class="container-gd" @click.stop>
            <div class="header">
              <p>管理员设置</p>
              <i
                class="fa-solid fa-circle-xmark"
                style="color: #8290a3; cursor: pointer"
                @click="showCollaborator = false"
              ></i>
            </div>
            <div
              style="
                font-size: 16px;
                font-weight: 500;
                color: #333333;
                width: 80%;
                text-align: center;
                margin-left: 10%;
                margin-bottom: 20px;
                margin-top: 20px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ collaboratorName }}
            </div>
            <div style="padding: 0 80px">
              <img :src="collaboratorQrCode" alt="二维码" class="qr-code" />
            </div>
            <div
              style="
                font-size: 14px;
                font-weight: 400;
                color: #7b818a;
                width: 80%;
                text-align: center;
                margin-left: 10%;
                margin-top: 20px;
              "
            >
              请扫码进入小程序邀请管理员
            </div>
            <button class="download-btn" @click="downloadQrCode">
              下载问卷二维码
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { templateList, infoFreeze, convertTemplate } from "@/api/userManagement/index";
import {
  userList,
  usercloseQuestionnaire,
  closeQuestionnaire,
  copyQuestionnaire,
  removeQuestionnaire,
  setQuestionnaireTop,
  getManageQrcode,
} from "@/api/index.js";
import questionTemplate from "@/components/QuestionTemplate/index.vue";

export default {
  components: {
    questionTemplate,
  },
  dicts: ["sys_job_status"],
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      clickItem: {},
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userKey: "",
        questionnaireName: "",
        releaseStatus: "",
      },
      dateRange: [],
      form: {
        id: "",
        dealInfo: "",
      },
      total: 0,
      currentPage: 1,
      isAddShow: false,
      islookShow: false,
      input: "",
      dataOne: "",
      peopleID: "",
      stateDic: [
        {
          label: "所有",
          value: "",
        },
        {
          label: "已发布",
          value: "1",
        },
        {
          label: "未发布",
          value: "2",
        },
      ],
      showDialog: false,
      lookId: "",
      showCollaborator: false,
      collaboratorQrCode: "",
      collaboratorName: "",
	  loading: false,
    };
  },
  created() {
    window.addEventListener("keyup", this.enterSearchOrder);
    // console.log(localStorage.getItem("token"),'localStorage.getItem("token")');
  },
  mounted() {
    this.queryParams.userKey = this.$route.query.peopleID;
    console.log(this.peopleID, "this.peopleID");
    this.getData();
  },
  methods: {
    beforeHandleCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command,
      };
    },

    handleCommand(command) {
      console.log("dhwvqwvfw12312312312312312", command);

      switch (command.command) {
        case "数据统计":
          this.$router.push({
            path: "/DataStatisticsPage/DataDetail",
            query: {
              uuid: command.row.uuid,
            },
          });
          break;
        case "重新编辑":
          this.$router.push({
            path: "/create",
            query: {
              id: command.row.uuid,
            },
          });
          break;
        case "创建副本":
          this.copyMethod(command.index, command.row);
          break;
        case "结束问卷":
          this.endMethod(command.index, command.row);
          break;
        case "删除问卷":
          this.deleteMethod(command.index, command.row);
          break;
        case "管理员设置":
          getManageQrcode({
            questionnaireUuid: command.row.uuid,
          }).then((res) => {
            console.log(res.data.base64, "res000000000000");
            if (res.code === 200) {
              this.collaboratorQrCode = res.data.base64;
              this.collaboratorName = command.row.questionnaireName;
              this.showCollaborator = true;
              // this.lookId = command.row.uuid;
            } else {
              this.$message.closeAll();
              this.$message({
                message: res.msg,
                type: "failed",
              });
            }
          });
          break;
        case "置顶":
        case "取消置顶":
          this.toggleTop(command.index, command.row);
          break;
      }
    },
    editClick(item) {
      console.log("qweweqwe112312321", item);

      this.$router.push({
        path: "/create",
        query: {
          id: item.uuid,
        },
      });
    },
    // 创建副本
    copyMethod(index, item) {
      console.log(item, "item");

      copyQuestionnaire({
        uuid: item.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            this.getData();
            this.$message.closeAll();
            this.$message({
              message: "成功",
              type: "success",
            });
          } else {
            this.$message.closeAll();
            this.$message({
              message: res.msg,
              type: "failed",
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 结束问卷
    endMethod(index, item) {
      console.log(item, "item");
      closeQuestionnaire({
        uuid: item.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            this.getData();
            this.$message.closeAll();
            this.$message({
              message: "成功",
              type: "success",
            });
          } else {
            this.$message.closeAll();
            this.$message({
              message: res.msg,
              type: "failed",
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    deleteMethod(index, item) {
      console.log(item, "item");
      this.$confirm("确认删除此问卷吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeQuestionnaire({
            uuid: item.uuid,
          })
            .then((res) => {
              if (res.code === 200) {
                this.getData();
                this.$message.closeAll();
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
              } else {
                this.$message.closeAll();
                this.$message({
                  message: res.msg,
                  type: "failed",
                });
              }
            })
            .catch((err) => {
              console.log("err", err);
            });
        })
        .catch(() => {});
    },
    // 重置
    getListReset() {
      // this.dateRange = []
      this.queryParams.releaseStatus = null;
      this.queryParams.questionnaireName = null;
      this.queryParams.userKey = null;
      this.currentPage = 1;
      this.queryParams.pageNum = 1;

      this.getData();
    },
    // 回车事件
    enterSearchOrder: function (e) {
      if (e.keyCode === 13) {
        this.queryParams.pageNum = 1;
        this.getData(); //这里的操作，是回车之后想要进行的操作，尽量全部写在一个方法里面
      }
    },
    getDataOne() {
      this.queryParams.pageNum = 1;
      this.currentPage = 1;
      this.getData();
    },
    // 查询数据
    getData() {
		this.loading = true
      userList({
        releaseStatus: this.queryParams.releaseStatus,
        pageNum: this.currentPage,
        questionnaireName: this.queryParams.questionnaireName,
        questionnaireType: "1",
      }).then((response) => {
        this.tableData = response.rows;
        this.total = response.total;
      })
	  .catch((err) => {
	        console.log("err", err);
	      })
	      .finally(() => {
	        this.loading = false;
	      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryParams.pageNum = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getData();
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.queryParams.pageNum = page;
      // 这里可以添加获取新页数据的逻辑
      console.log("切换到页码:", page);
      this.getData();
    },
    // 查看详情
    handleShareClick(item) {
      //   this.clickItem = item;
      console.log("this.clickItem", item);
      //   this.dialogVisible = true;
      this.showDialog = true;
      this.lookId = item.uuid;
    },
    // 发布问卷
    fbClick(item) {
      this.$confirm(
        "当前问卷处于可编辑状态，尚未发布，是否确认现在发布？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          usercloseQuestionnaire({
            uuid: item.uuid,
          }).then((res) => {
            if (res.code === 200) {
              // uni.reLaunch({
              // 	url: '/pages/MyQuestionnaire/MyQuestionnaire'
              // })
              this.getData();
              this.$message.closeAll();
              this.$message({
                message: "成功",
                type: "success",
              });
            } else {
              this.$message.error("失败");
            }
          });
        })
        .catch(() => {});
    },
    copyClick() {
      // 复制逻辑
      console.log("复制链接");
      // 复制逻辑
      const input = document.createElement("input");
      input.value = this.clickItem.qrCode;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },

    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        // 背景设置成白色
        context.fillStyle = "#fff";
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    downs() {
      this.downloadIamge(this.clickItem.qrCode, "二维码");
    },
    setManager() {},
    toggleTop(index, item) {
      setQuestionnaireTop({
        uuid: item.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            this.currentPage = 1;
            this.getData();
            this.$message.closeAll();
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message.closeAll();
            this.$message({
              message: res.msg,
              type: "failed",
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    downloadQrCode() {
      const name = this.collaboratorName;
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height + 100;
        var context = canvas.getContext("2d");

        // 背景设置成白色
        context.fillStyle = "#fff";
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 46, image.width, image.height);

        // 添加标题
        context.fillStyle = "#000000"; // 文字颜色
        context.font = "16px Arial"; // 字体和大小
        context.textAlign = "center"; // 文字对齐方式
        context.fillText(name, canvas.width / 2, 36);

        // 添加更多文字
        context.fillStyle = "#7b818a"; // 红色文字
        context.font = "14px";
        context.textAlign = "center";
        context.fillText(
          "请扫码进入小程序邀请管理员",
          canvas.width / 2,
          canvas.height - 26
        );

        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = this.collaboratorQrCode;
      this.showCollaborator = false;
    },
  },
};
</script>

<style scoped>
.el-main {
  background-color: #f6f6fb;
}

/* .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 240px;
} */

.huise {
  width: 100%;
  height: 100vh;
  background-color: rgba(000, 000, 000, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.tanchuang {
  min-width: 397px;
  padding: 0 0 20px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  position: relative;
}

.tanchuang .el-icon-close {
  position: absolute;
  right: 13px;
  top: 18px;
  cursor: pointer;
}

.tanchuang .top1 {
  width: 100%;
  height: 50px;
  background-color: #eaeaea;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 17px;
}

.tanchuang .content1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 40px;
  box-sizing: border-box;
}

.tanchuang .content1 .allview {
  display: flex;
  align-items: flex-start;
  margin-bottom: 17px;
}

.tanchuang .content1 .allview span {
  display: block;
  width: 95px;
  font-size: 16px;
  color: #6a6a6a;
  text-align: end;
}

/* .tanchuang .content1 .allview .el-input {
  width: 196px;
  height: 30px;
} */

.tanchuang .content1 .allview div {
  font-size: 16px;
  color: #6a6a6a;
}

.tanchuang .el-button {
  background-color: #086ed9;
  color: #ffffff;
  cursor: pointer;
}

.bigcontent {
  padding: 0 10px;

  width: 100%;
  /* min-width: 1000px; */
  /* padding: 10px; */
  box-sizing: border-box;
  /* margin-top: 35px; */
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  background: #ffffff;
}

.bigcontent .top {
  /* // width: 100%; */
  background-color: #ffffff;
  padding: 20px;
}

.bigcontent .top .topfirst {
  display: flex;
  align-items: center;
}

.bigcontent .top .topfirst .inpstyle {
  display: flex;
  align-items: center;
  margin-right: 30px;
}

.bigcontent .top .topfirst .inpstyle p {
  /* display: block; */
  /* width: 80px; */
  font-size: 14px;
  color: #2f4257;
  white-space: nowrap;
  margin-right: 10px;
  /* margin-bottom: 3px; */
}

/* .bigcontent .top .topfirst .inpstyle .el-input {
  width: 240px;
}

.bigcontent .top .topfirst .inpstyle .el-input .el-input__inner {
  border: none;
} */

/* .bigcontent .top .topfirst .inpstyle .el-select {
  width: 240px;
} */

/deep/ .inpstyle .el-select .el-input .el-input__inner {
  border: 1px solid #e6e6e6;
}

.bigcontent .content {
  /* is-scrolling-none */
  background: #fff;
}

.bigcontent .content .isReleaseTrue {
  background: #fea951;
  border-radius: 10px;
  padding: 5px 8px;
  color: #fff;
}

.bigcontent .content .isReleaseFalse {
  background: #d8d8d8;
  border-radius: 10px;
  padding: 5px 8px;
  color: #fff;
}

.bigcontent .content .custom-questionnaire-column {
}

/deep/.bigcontent .content .custom-questionnaire-column .cell {
  padding-left: 20px;
}

.bigcontent .content .custom-questionnaire-column .text {
  display: block;
  width: 88%;
}

.bigcontent .content .custom-questionnaire-column .ifTop {
  color: #00b380;
  text-align: center;
  font-size: 12px;
  line-height: 24px;
  margin-right: 12px;
  background: linear-gradient(
    180deg,
    rgba(0, 179, 128, 0.11),
    rgba(0, 179, 128, 0)
  );
  border-radius: 10px;
  padding: 0px 8px;
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
}

.betweenFlx {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.columnFlx {
  /* display: flex;
  flex-direction: column; */
}

.flexStart {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.pagination {
  /* margin-bottom: 10px; */
  padding-bottom: 10px;
}

.el-pagination {
  float: right;
}

.el-table .el-table__header-wrapper th,
.el-table .el-table__fixed-header-wrapper th {
  background-color: #edf2fa;
}

.el-drawer__container {
  position: relative;
  top: 200px;
  right: 40%;
}

/* // 弹窗样式 */
.bigcontent1 {
  width: 100%;
  height: 420px;
  padding: 10px;
  box-sizing: border-box;
}

.bigcontent1 .alldiv {
  background-color: #ffffff;
  padding: 18px;
  box-sizing: border-box;
  height: 420px;
  overflow: auto;
}

.bigcontent1 .biao {
  width: 100%;
  display: flex;
  align-items: center;
}

.bigcontent1 .biao span {
  display: block;
  width: 5px;
  height: 14px;
  background-color: #5174f0;
  border-radius: 2px;
  margin-right: 10px;
}

.bigcontent1 .biao h2 {
  font-size: 16px;
  color: #0f0f0f;
}

.bigcontent1 .allinp {
  padding: 10px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.bigcontent1 .allinp .inpstyle {
  min-width: 240px;
  display: flex;
  flex-direction: column;
  margin-right: 30px;
}

.bigcontent1 .allinp .inpstyle span {
  font-size: 16px;
  color: #2f4257;
  margin-bottom: 3px;
}

.bigcontent1 .allinp .inpstyle el-input {
  width: 100%;
}

.bigcontent1 .allinp .selBiao {
  font-size: 16px;
  margin-right: 10px;
  font-weight: 600;
}

.bigcontent1 .allinp .selStyle {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.bigcontent1 .allinp .selStyle span {
  font-size: 14px;
  color: #0f0f0f;
  margin-right: 10px;
}

.bigcontent1 .message {
}

.bigcontent1 .message span {
  font-size: 14px;
  color: #5174f0;
  margin-bottom: 12px;
  cursor: pointer;
}

.bigcontent1 .footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.left-panel {
  /* // flex: 1; */
  background: #007aff;
  color: white;
  border-radius: 10px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  width: 120px;
  margin-bottom: 15px;
}

.beta {
  background: yellow;
  color: black;
  padding: 5px 10px;
  border-radius: 3px;
  margin-bottom: 20px;
}

.title {
  font-size: 36px;
  margin-bottom: 30px;
}

.card {
  background: white;
  color: #007aff;
  padding: 25px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.card-title {
  font-size: 24px;
  margin-bottom: 15px;
  display: inline-block;
  max-width: 14ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qr-code {
  width: 180px;
}

.footer {
  display: flex;
  align-items: center;
  margin-top: auto;
}

.mini-logo {
  width: 40px;
  margin-right: 10px;
}

.right-panel {
  flex: 1;
  padding-left: 40px;
}

.info-box,
.link-box {
  margin-bottom: 30px;
}

.info-title,
.link-title {
  color: #007aff;
  border-bottom: 2px solid #007aff;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.info-item {
  margin: 8px 0;
}

.link-input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn-group {
  display: flex;
  gap: 15px;
  margin-top: 10px;
}

.btn {
  background: #007aff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.close-btn {
  background: #007aff;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 4px;
  font-size: 16px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #007aff;
  font-size: 12px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1009;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1009;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  /* width: 600px; */
  /* height: 600px; */
  background: #ffffff;
  z-index: 1009;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

.header {
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;

  p {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: 600;
  }

  i {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

.download-btn {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background: #3a60ff;
  cursor: pointer;
  height: 44px;
  width: 50%;
  border-radius: 22px;
  margin-left: 25%;
  margin-top: 20px;
  margin-bottom: 20px;
}

/* .analy-btn {
  width: 100%;
  display: flex;
  border-top: 1px solid #e7e7e7;

  .analy-cancel {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    background: none;
    cursor: pointer;
    height: 51px;
  }

  .analy-confirm {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    background: #2563eb;
    cursor: pointer;
    height: 51px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/views/MyPage/index.vue